export default __webpack_public_path__ + "svg/why/ponder.svg?e70d4367";